'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

import { cn } from '@/libs';

type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const Container = ({ children, className, ...props }: ContainerProps) => {
  return (
    <main
      className={cn('w-full flex-1 flex flex-col p-2 pb-0 gap-2', className)}
      {...props}
    >
      {children}
    </main>
  );
};
